import BaseListPresenter from "../../base/BaseListPresenter";
class DashboardPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    upsertUseCase,
    updateSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
  }

  async componentDidMount() {
    // Run all initial fetches in parallel for speed
    await Promise.all([
      this.init(),
      this.getAllApplications(),
      this.getObjects(),
    ]);
  }

  async init() {
    const { status, startDate, endDate, currentDate } = this.view.state;

    let isoStart, isoEnd;
    if (startDate && endDate) {
      const start = new Date(startDate);
      start.setHours(0, 0, 0, 0);
      const end = new Date(endDate);
      end.setHours(23, 59, 59, 999);
      isoStart = start.toISOString();
      isoEnd = end.toISOString();
    } else {
      const today = new Date(currentDate);
      const startOfToday = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate()
      );
      startOfToday.setHours(0, 0, 0, 0);
      const endOfToday = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate()
      );
      endOfToday.setHours(23, 59, 59, 999);
      isoStart = startOfToday.toISOString();
      isoEnd = endOfToday.toISOString();
    }

    this.limit = 20;
    this.where = { status, created: { $gte: isoStart, $lte: isoEnd } };
    this.include = ["all"];
    this.sort = { created: -1 };
    this.progress = true;
    this.reset();
  }

  showMetricProgress() {
    this.view.setState({ metricsProgress: true });
  }

  hideMetricProgress() {
    this.view.setState({ metricsProgress: false });
  }

  async getAllApplications() {
    const baseQuery = this.createQuery();
    delete baseQuery.where.status;
    delete baseQuery.limit;

    const statuses = [
      "New",
      "For Interview",
      "For Coordinator",
      "On-boarding",
      "Hired",
      "Not Hired",
    ];

    try {
      this.showMetricProgress();

      const statusResults = await Promise.all(
        statuses.map(async (status) => {
          const statusQuery = {
            ...baseQuery,
            where: { ...baseQuery.where, status: status },
          };

          console.warn(statusQuery);

          const [online, walkIn, reprocess] = await Promise.all([
            this.countObjectUseCase.execute("online_applicants", statusQuery),
            this.countObjectUseCase.execute("walkIn_applicants", statusQuery),
            this.countObjectUseCase.execute(
              "reprocess_applicants",
              statusQuery
            ),
          ]);

          const totalCount = online.count + walkIn.count + reprocess.count;

          return { status, count: totalCount };
        })
      );

      const metricsData = {};
      statusResults.forEach(({ status, count }) => {
        metricsData[status] = count;
      });

      this.view.setState({ metricsData: metricsData });
    } catch (error) {
      this.view.showError(error);
    } finally {
      this.hideMetricProgress();
    }
  }

  async findObjects() {
    const query = this.createQuery();

    try {
      this.showProgress();
      this.findObjectUseCase.abort();

      const [online, walkIn, reprocess] = await Promise.all([
        this.findObjectUseCase.execute("online_applicants", query),
        this.findObjectUseCase.execute("walkIn_applicants", query),
        this.findObjectUseCase.execute("reprocess_applicants", query),
      ]);

      const allFetchedObjects = [...online, ...walkIn, ...reprocess].sort(
        (a, b) => new Date(b.created) - new Date(a.created)
      );
      this.objects = [...this.objects, ...allFetchedObjects];

      this.view.setTotal(this.objects.length);
      this.view.setObjects(this.objects);
    } catch (error) {
      this.view.showError(error);
    } finally {
      this.hideProgress?.();
    }
  }
}

export default DashboardPresenter;
